import { render } from "./ImageUploadDragger.vue?vue&type=template&id=0783b7ce&scoped=true"
import script from "./ImageUploadDragger.vue?vue&type=script&lang=js"
export * from "./ImageUploadDragger.vue?vue&type=script&lang=js"

import "./ImageUploadDragger.vue?vue&type=style&index=0&id=0783b7ce&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0783b7ce"]])

export default __exports__